import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {GoogleMapBase, PlaceDetails} from '@Components/google-map/google-map.types';

export interface GoogleMapSelectorModalProps extends GoogleMapBase {
  selectedVenue: PlaceDetails | undefined;
  onLoaded?: () => void;
}

export function openGoogleMapSelectorModal(props: GoogleMapSelectorModalProps): void {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.GOOGLE_MAP_SELECTOR_MODAL,
      panelProps: {
        googleMapAPIKey: props.googleMapAPIKey,
        onLocationChange: props.onLocationChange,
        defaultSelectedLocation: props.selectedVenue,
        onLoaded: props.onLoaded,
      },
    })
  );
}
